import yup from './yup'

export const venueFormSchema = yup.object().shape({
  title: yup.string().label('Venue name').trimmedRequired('Venue name is required')
})
